import types from "../actions/actionTypes";
import initialState from "./initialState";

const projectInvoicesTableOpenReducer = (state = initialState.projectInvoicesTableOpen, action) => {

    const updateInvoice = (invoices, invoice) => {
        return invoices.filter(i => i.id !== invoice.id)
            .concat(invoice);
    }

    const toggleInvoice = (invoices, invoiceId) => {
        const invoice = invoices.find(ph => ph.id === invoiceId);
        if (invoice === undefined) {
            return invoices;
        }
        const newOpen = !invoice.open;
        const updatedInvoice = { ...invoice, open: newOpen };
        return updateInvoice(invoices, updatedInvoice);
    }

    switch (action.type) {
        case types.UPDATE_PROJECT_INVOICES_OPEN:
            return updateInvoice(state, action.invoice);
        case types.UPDATE_PROJECT_INVOICES_OPEN_TOGGLE:
            return toggleInvoice(state, action.invoice.id);
        default:
            return state;
    }
}

export default projectInvoicesTableOpenReducer;